/**
 * Formats a date string in a friendly French format:
 * - "auj. à hh:mm" when it's today
 * - "hier à hh:mm" when it's yesterday
 * - "le dd fév. à hh:mm" when it's this year
 * - "le dd fév. 2025" when it's before this year
 */
export const formatFriendlyDate = (dateString: string): string => {
    const date = new Date(dateString);
    const now = new Date();
    
    // Reset time to midnight for date comparison
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    
    const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    
    // Format time as hh:mm
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const timeStr = `${hours}:${minutes}`;
    
    // French month abbreviations
    const monthAbbreviations = [
        'janv.', 'fév.', 'mars', 'avr.', 'mai', 'juin',
        'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'
    ];
    
    // Check if it's today
    if (dateOnly.getTime() === today.getTime()) {
        return `auj. à ${timeStr}`;
    }
    
    // Check if it's yesterday
    if (dateOnly.getTime() === yesterday.getTime()) {
        return `hier à ${timeStr}`;
    }
    
    const day = date.getDate();
    const month = monthAbbreviations[date.getMonth()];
    const year = date.getFullYear();
    const currentYear = now.getFullYear();
    
    // Check if it's this year
    if (year === currentYear) {
        return `le ${day} ${month} à ${timeStr}`;
    }
    
    // Previous years
    return `le ${day} ${month} ${year}`;
};

